import React, { useEffect, useRef, useState } from "react";
import {
  Card, CardBody, Col, Container, Row, Breadcrumb, BreadcrumbItem, Nav, NavItem, NavLink, TabPane, TabContent, Button,
} from "reactstrap";
import classnames from "classnames";
import Tooltipp from "react-bootstrap/Tooltip";
import CommentTab from "./tab/CommentTab";
import HistoryTab from "./tab/HistoryTab";
import WorkLogTab from "./tab/WorkLogTab";
import { useNavigate, useParams } from "react-router-dom";
import { showTicket, updateTicket, updateTicketStatus } from "../../api/casp/ticket";
import { Avatar, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { OverlayTrigger } from "react-bootstrap";
import SelectDropdown from "../../Components/casp/common/SelectDropdown";
import { BoardName } from "../../constants/Board";
import { AllStatusList } from "../../api/casp/status";
import { AllPriorityList } from "../../api/casp/priority";
import { AllTicketTypeList } from "../../api/casp/ticketType";
import { toast } from "react-toastify";
import { Priority } from "../../constants/Priority";
import { getUserList } from "../../api/casp/user";
import { SearchDropDownListComponent } from "../../Components/casp/common/SearchDropDownList";
import SearchDropDownListPaginationComponent from "../../Components/casp/common/SearchDropDownPaginationList";
import TextEditor from "../../Components/casp/common/TextEditor";
import FormControl from "@mui/material/FormControl";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { ProjectStatuses, TicketStatuses } from "../../constants/Status";
import { ucFirst } from "../../helpers/string_helper";
import { Modules } from "../../constants/Module";
import DownloadIcon from '@mui/icons-material/Download';
import { deleteDocument, documentList, uploadFile } from "../../api/casp/document";
import { getUrl, truncateFileName } from "../../helpers/file_helper";
import FilePreviewModal from "../../Components/casp/common/FilePreviewModal";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
// import AttachFileIcon from '@material-ui/icons/AttachFile';
import SweetAlert from "react-bootstrap-sweetalert";
// import { makeStyles } from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../Components/Common/Loader";
import NodataFound from "../../Components/Common/NoDataFound";
// import Attachment from "../../assets/images/icons/attachment.png";
import { AcceptFileType, Action, DefaultPerPageValue } from "../../constants/Common";
import { TicketType } from "../../constants/TicketType";
import { Helmet } from 'react-helmet';
import { getIconPath } from "../../helpers/file_helper";
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { getProjectDetails } from "../../api/casp/project";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { BorderLeft } from "@mui/icons-material";
import PriorityIcon from "../../Components/Icon/priority";
import { color } from "echarts";
import { withTranslation } from "react-i18next";
import NotFound from "../../Components/Common/PageNotFound";

const useStyles = makeStyles({
  blueIcon: {
    color: '#296ced',
    cursor: 'pointer'
  },
});
const TicketDetailsPage = ({t}) => {
  const [activeTab, setActiveTab] = useState("1");
  const { projectId, ticketId } = useParams();
  const [update, setUpdate] = useState(0);
  const [ticket, setTicket] = useState({});
  const [statusList, setStatusList] = useState([]);
  const [priorityList, setPriorityList] = useState([]);
  const [ticketTypeList, setTicketTypeList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [selectedTicketType, setSelectedTicketType] = useState(null);
  const [projectStatus, setProjectStatus] = useState();
  const [selectedAssginee, setSelectedAssginee] = useState(null);
  const [ticketName, setTicketName] = useState("");
  const [isEditingName, setIsEditingName] = useState(false);
  const [ticketDesc, setTicketDesc] = useState("");
  const [refreshComponentKeyDesc, setRefreshComponentKeyDesc] = useState({
    description: +new Date() + 'description',
  })
  const [refreshOtherComponent, setRefreshOtherComponent] = useState({
    assignee: `${+new Date()}_assignee`,
    status: `${+new Date()}_status`,
    priority: `${+new Date()}_priority`,
    stDate: `${+new Date()}_stDate`,
    edDate: `${+new Date()}_edDate`
  })
  const [isDateUpdate, setIsDateUpdate] = useState("");
  const [mounted, setMounted] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [stausDisable, setStausDisable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [taskDocumets, setTaskDocuments] = useState([]);
  const [modal, setModal] = useState(false);
  const [filePath, setFilePath] = useState('');
  const [fileName, setFileName] = useState('');
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const classes = useStyles();
  const tomDate = new Date();
  tomDate.setDate(tomDate.getDate() + 1);
  const inputRef = useRef(null)

  useEffect(() => {
    fetchTicketDetails();
    getDocumentList();
    getStatusList();
    getPriorityList();
    getTicketTypeList();
    fetchProjectDetails (projectId);
  }, []);

  const fetchProjectDetails = async(projectId) => {
    try {
      const res = await getProjectDetails(projectId)
      setProjectStatus(res.data.data.status)
    } catch(e) {
      console.log(e)
    }
  }

  const getDocumentList = async (type) => {
    try {
      setLoadingDocument(true)
      let params = {
        page: (type === Action.DELETE || type === Action.CREATE) ? 1 : page,
        perPage: DefaultPerPageValue,
        projectId,
        filterFields: ['documentAssociations'],
        filterInputs: '',
        module: [Modules.TICKET],
        moduleId: ticketId
      };
      const res = (await documentList(params)).data.data;
      if (type === Action.DELETE || type === Action.CREATE) {
        setTaskDocuments([...res.data])
        setPage(res.meta.currentPage + 1)
        setHasMore(res.meta.currentPage !== res.meta.lastPage);
      } else {
        setTaskDocuments((prevState) => {
          return [...prevState, ...res.data];
        });
        setPage((prev) => prev + 1)
        setHasMore(res.meta.currentPage !== res.meta.lastPage);
      }
    }
    catch (error) {
      console.log(error)
    }
    finally {
      setLoadingDocument(false)
    }

  }
  const handleFileUpload = async (file) => {
    try {
      if (file.size > (1024 * 1024 * 10)) {
        toast.error('Payload content length greater than maximum allowed: 10 MB');
        return
      }
      setLoadingDocument(true)
      const formData = new FormData();
      formData.append('files', file);
      formData.append('moduleId', ticketId);
      formData.append('module', Modules.TICKET);
      formData.append('projectId', projectId);
      const result = (await uploadFile(formData)).data.data;
      getDocumentList(Action.CREATE)
    } catch (error) {
      console.log(error)
      setLoadingDocument(false)
    }
    finally {
      setLoadingDocument(false)
    }
  }

  const handelDelete = async () => {
    setIsOpenSweetAlert(false)
    setLoadingDocument(true)
    try {
      const res = await deleteDocument(documentId)
      toast.success(res.data.message)
      getDocumentList(Action.DELETE)
      setDocumentId()
    } catch (err) {
      setLoadingDocument(false)
      toast.error(err.message)
    }
    finally {
      setLoadingDocument(false)
      setDocumentId()
    }
  }

  const handleBackClick = () => {
    navigate(-1); //navigate to back page
  };

  const updateTicketDetails = async (params) => {
    try {
      setIsLoading(true)
      const payload = {
        ticketTypeId: selectedTicketType?.id ?? ticket?.ticketType?.id,
        name: ticket.name,
        description: ticket.description,
        ...(ticket.startDate && { startDate: ticket.startDate }),
        ...(ticket.endDate && { endDate: ticket.endDate }),
        priorityId: ticket?.priority?.id,
        assigneeId: selectedAssginee?.id,
        projectId,
        ...params,
      };
      const res = await updateTicket(ticketId, payload);
      toast.success(res.data.message);
    } catch (error) {
      toast.error(error.message);
    } finally {
      await fetchTicketDetails();
      setRefreshComponentKeyDesc((prev) => {
        return { ...prev, description: +new Date() + 'description' }
      })
      setRefreshOtherComponent((value) => {
        value.assignee = `${+new Date()}_assignee`;
        value.status = `${+new Date()}_status`;
        value.priority = `${+new Date()}_priority`;
        value.stDate = `${+new Date()}_stDate`;
        value.edDate = `${+new Date()}_edDate`;

        return {...value}
      })
      setIsLoading(false)
    }
  };

  // Update ticket status
  const changeTicketStatus = async (statusId) => {
    try {
      setIsLoading(true)
      const response = await updateTicketStatus(
        { ticketId, statusId },
        { projectId }
      );
      toast.success(response.data.message);
      await fetchTicketDetails();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false)
    }
  };

  const fetchTicketDetails = async () => {
    try {
      setIsLoading(true)
      const res = await showTicket(ticketId, { projectId });
      setIsDisabled(TicketStatuses.DONE === res.data.data.status.name);
      setStausDisable(ProjectStatuses.ONGOING !== res.data.data.project.status);
      setTicket(res.data.data);
      setSelectedPriority({
        id: res.data.data.priority?.id  ?? '',
        label: res.data.data.priority?.name        ??   '',
        color: res.data.data.priority?.color ?? '',
        key:res.data.data.priority ? `${res.data.data.priority.id}|${ res.data.data.priority.name}`: '',
      });
      setSelectedAssginee({
        id: res.data.data.assignee?.id,
        label: res.data.data.assignee?.name,
        profilePicture: res.data.data.assignee?.profilePicture,
      });
      setSelectedStatus(res.data.data.status);
      setTicketName(res.data.data.name);
      setTicketDesc(res.data.data.description);
      setMounted(true);
      setUpdate((prev) => prev + 1)
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false)
    }
  };

  const getStatusList = async () => {
    try {
      const statusApiParams = {
        projectId,
        filterFields: ["board"],
        filterInputs: [BoardName.KANBAN],
        excludeFilterFields: ["name"],
        excludeFilterInputs: [
          `${TicketStatuses.IN_APPROVAL},${TicketStatuses.REJECTED}, ${TicketStatuses.DRAFT}`,
        ],
      };
      const res = await AllStatusList(statusApiParams);
      if (res.data.data.data.length > 0) {
        const result = res.data.data.data.map((item) => ({
          id: item.id,
          name: ucFirst(item.name)
        }))
        setStatusList(result);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getPriorityList = async () => {
    try {
      const priorityApiParams = {
        projectId,
      };
      const res = await AllPriorityList(priorityApiParams);
      if (res.data.data.data.length > 0) {
        const result = res.data.data.data.map((item) => ({
          id: item.id,
          name: ucFirst(item.name)
        }))
        setPriorityList(result);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getTicketTypeList = async () => {
    try {
      const ticketTypeApiParams = {
        projectId: projectId,
        excludeFilterFields: ["name"],
        excludeFilterInputs: [`${TicketType.EPIC},${TicketType.CS},${TicketType.SUB_TASK}`]
      };
      const res = (await AllTicketTypeList(ticketTypeApiParams)).data.data;
      if (res.data.length > 0) {
        setTicketTypeList(res.data);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const priorityColor = (priority) => {
    const color = {
      [Priority.HIGHEST]: "danger",
      [Priority.HIGH]: "danger",
      [Priority.MEDIUM]: "warning",
      [Priority.LOW]: "success",
    };
    return color[priority] || color["Low"];
  };

  const assigneeApiParams = {
    projectId,
    filterFields: ["projectUser"],
    filterInputs: [projectId],
    isActive: true
  };

  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  function stringAvatar(name) {
    if (!name) {
      return {};
    }
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
    };
  }

  const copyContent = async () => {
    try {
      const linkUrl = window.location.href;
      await navigator.clipboard.writeText(linkUrl);
      toast.success("Link copied.");
    } catch (err) {
      toast.error("Failed to copy.");
    }
  };

  const commentNavlinks = [
    {
      name: t('Comment'),
      link: '#',
      toggleTab: '1',
    },
    {
      name: t('History'),
      link: '#',
      toggleTab: '2',
    },
    // {
    //   name: 'Work Log',
    //   link: '#',
    //   toggleTab: '3',
    // },
  ];

  useEffect(() => {
    setActiveTab('1');
  }, []);

  useEffect(() => {
    if (mounted) {
      updateTicketDetails();
    }
  }, [isDateUpdate]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <div className="page-content">
      <Helmet
        onChangeClientState={(newState, addedTags) => {
          try {
            // Check if we added any new link[rel="icon"] elements.
            const newFaviconElems = filter(get(newState, 'linkTags', []), {
              rel: 'icon',
            })

            if (!newFaviconElems.length) {
              return
            }

            // Get the href of the last link element we just added, which
            // we assume is the most recently-added favicon.
            const newFaviconHref =
              newFaviconElems[newFaviconElems.length - 1].href

            // Remove all react-helmet link elements with rel="icon" that
            // do not have the href of our recently-added favicon.
            // If no other favicon elements exist, we don't have to do
            // anything.
            const existingFavicons = document.querySelectorAll(
              `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
            )

            if (existingFavicons.length) {
              existingFavicons.forEach(e => e.parentNode.removeChild(e))
            }

            // Remove and re-add the latest link element to make sure
            // the browser uses it.
            const newFaviconElem = document.querySelector(
              `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
            )

                if (newFaviconElem) {
                    const newFavElement = newFaviconElem.cloneNode(true)
                    newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                        `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(<CheckBoxOutlinedIcon />)}</svg>`
                      )}`
                    const parentElem = newFaviconElem.parentNode
                    parentElem.removeChild(newFaviconElem)
                    parentElem.appendChild(newFavElement)
                }
                } catch (e) {
                console.error(e)
                }
            }}
        >
            <title>{t('Ticket Details')}</title>
        </Helmet>
      <Container fluid>
      {ticketName &&
      <>
        <Row>
          <Breadcrumb className="breadcrumb_border_bottom">
            <BreadcrumbItem>
              <div style={{ fontSize: "16px", cursor: 'pointer' }} onClick={handleBackClick}>
                <i className="las la-arrow-left"></i> {t('Startup')} {t(projectId)}
              </div>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <a href="#" style={{ fontSize: "14px" }}>
                {t('Board')}
              </a>
            </BreadcrumbItem>
            <BreadcrumbItem active style={{ fontSize: "14px" }}>
              #CASP-{ticketId}
            </BreadcrumbItem>
          </Breadcrumb>
        </Row>
        <Row className="g-3 row-eq-height">
          <Col lg={8} className="h-100">
            <Card className="h-100 detailPgCard" style={{boxShadow: 'unset'}}>
              <CardBody>
                <div className="taskName customTextField">
                  <TextField
                    value={ticketName}
                    onChange={(event) => {
                      setTicketName(event.target.value);
                    }}
                    disabled={isDisabled || isLoading}
                    onFocus={(event) => {
                      setIsEditingName(true);
                    }}
                    onBlur={(e) => {
                      if (!['name-done', 'name-cancel'].includes(e.relatedTarget?.id)) {
                        setIsEditingName(false);
                        setTicketName(ticket.name)
                      }
                    }}
                    fullWidth
                    variant="standard"
                    InputProps={{
                      style: {
                        fontSize: 28,
                        background: "rgb(232, 241, 250)",
                        paddingLeft: 8,
                        padding: 8,
                      },
                      // disableUnderline: isEditingName ? false : true,
                    }}
                  />
                </div>
                {isEditingName ? (
                  <div className="d-flex justify-content-end">
                    <div className="gap-2 mt-2 position-absolute">
                      <Button
                        id="name-done"
                        color="light"
                        className="btn-border me-2"
                        disabled={isDisabled || isLoading}
                        onClick={(event) => {
                          if (ticketName !== ticket.name && ticketName.trim().length === ticketName.length) {
                            updateTicketDetails({ name: ticketName });
                          } else {
                            toast.error('Must not include leading and trailing spaces');
                            setTicketName(ticket.name);
                          }
                          setIsEditingName(false);
                        }}
                      >
                        <i className="ri-check-line align-bottom"></i>
                      </Button>
                      <Button
                        id="name-cancel"
                        color="light"
                        className="btn-border"
                        onClick={(event) => {
                          setIsEditingName(false);
                          setTicketName(ticket.name);
                        }}
                      >
                        <i className="ri-close-line align-bottom"></i>
                      </Button>
                    </div>
                  </div>
                ) : null}
                {/* <div className="d-flex mb-2 mt-2 gap-2">
                  <span className="bg-info border-0 btn btn-secondary mt-3">
                    Task
                  </span>
                  <div className="mt-3">
                    <Button
                      color="light"
                      className="btn-border"
                      onClick={(event) => copyContent()}
                    >
                      <i
                        className="ri-links-fill align-bottom"
                        color="#293CCA"
                      ></i>
                    </Button>
                  </div>
                </div> */}
                <div className="desc_box my-4">
                  {/* <h5 className="mb-3 desc_common_heading">{t('Description')}</h5> */}
                  {ticketDesc && ticket.description !== null && (
                    <TextEditor
                      key={refreshComponentKeyDesc.description}
                      toolbarId={'ticket-description-content'}
                      content={ticketDesc}
                      disabled={isDisabled || isLoading}
                      emitItem={(newValue) => {
                        let pattern = /(<([^>]+)>)/gi;
                        let descriptionText = newValue.replace(pattern, '');

                        if (descriptionText.trim().length === descriptionText.length) {
                          updateTicketDetails({ description: descriptionText.length ? newValue : null});
                        } else {
                          toast.error('Must not include leading and trailing spaces');
                          setRefreshComponentKeyDesc((prev) => {
                            return { ...prev, description: +new Date() + 'description' }
                          })

                        }
                      }}
                    />
                  )}
                  {ticket.description === null && (
                    <TextEditor
                      toolbarId={'ticket-description-no-content'}
                      value={ticketDesc}
                      disabled={isDisabled || isLoading}
                      emitItem={(newValue) => {
                        updateTicketDetails({ description: newValue });
                      }}
                    />
                  )}
                </div>
                <div className="attachement_container my-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-3 desc_common_heading">{t('Attachments')}</h5>
                    <div className='d-flex justify-content-end align-items-center mb-2'>
                      <Button
                        size="sm"
                        variant="contained"
                        // className="popupButton edit_button ps-1"
                        className="popupButton edit_button w-100 main-login-btn btn btn-secondary d-flex align-items-center btn btn-secondary btn-height-30"
                        onClick={(e) => {
                          inputRef.current.click()
                        }}
                      >
                        <FileDownloadOutlinedIcon style={{ transform: 'rotate(180deg)' }} /> &nbsp; {t('Upload')}
                      </Button>
                      <input accept={AcceptFileType.toString()} onChange={(e) => handleFileUpload(e.target.files[0])} ref={inputRef} type='file' style={{ display: 'none' }} single />
                    </div>
                  </div>
                  {!loadingDocument ?
                    <InfiniteScroll
                      dataLength={taskDocumets.length}
                      next={getDocumentList}
                      hasMore={hasMore}
                      height={taskDocumets.length ? "100px" : "auto"}
                      loader={loadingDocument && <Loader />}
                    >

                      <div className="d-grid globalAttachmentList mb-3">
                        {
                          taskDocumets?.length > 0 && taskDocumets.map((document, key) => (
                            <div key={key} className="singleAttachment mt-1 d-flex align-items-center justify-content-between">
                              <div className='d-flex justify-content-between w-100'>
                                <div className='d-flex'>
                                <div style={{ cursor: 'pointer' }} onClick={() => {
                                  setModal(true)
                                  setFilePath(getUrl(document.storageLink))
                                  setFileName(document.name)
                                }
                                }>

                                  <div className="attachmentFileIcon">
                                    <DescriptionOutlinedIcon />
                                  </div>
                                </div>
                                <div className="filename d-flex align-items-center justify-content-between">
                                  <span className="w-semibold text-truncate" onClick={() => {
                                    setModal(true)
                                    setFilePath(getUrl(document.storageLink))
                                    setFileName(document.name)
                                  }
                                  } style={{ cursor: 'pointer', width: '150px', display: 'inline-block' }}>{document.name}</span>

                                </div>
                                </div>
                                  <div className="proSubmissionActions"
                                    style={{ display: "flex", alignItems: "center" }}
                                  >
                                    <a style={{ cursor: 'pointer' }} href={`${getUrl(document.storageLink)}?httpResponseContentDisposition=attachment%3B%20filename%3D${document.name}`} download >
                                      <DownloadIcon />
                                    </a>
                                    <RemoveRedEyeOutlinedIcon className={classes.blueIcon} onClick={() => {
                                      setModal(true)
                                      setFilePath(getUrl(document.storageLink))
                                      setFileName(document.name)
                                    }
                                    } />
                                    <DeleteOutlineOutlinedIcon className={classes.blueIcon} onClick={() => {
                                      setDocumentId(document.id)
                                      setIsOpenSweetAlert(true)
                                    }} />
                                  </div>
                              </div>

                            </div>
                          ))
                        }
                        {!taskDocumets.length && !loadingDocument && (
                          <div className="noAttachmentFound w-100">
                            <NodataFound text={t("No Attachments")} icon="" />
                          </div>
                        )}
                      </div>
                    </InfiniteScroll>
                    :
                    <Loader />
                  }
                </div>
                <div className="activities_sec">
                  <h5 className="mb-3 desc_common_heading">{t('Activity')}</h5>
                  <div className="allTabs my-3">
                    <Nav
                      className="nav-tabs-custom"
                      role="tablist"
                    >
                      {commentNavlinks.map((item, index) => (
                        <NavItem key={index}>
                          <NavLink
                            className={classnames(
                              { active: activeTab === item.toggleTab },
                              "single_navlink"
                            )}
                            onClick={() => {
                              toggleTab(item.toggleTab);
                            }}
                            href={item.link}
                          >
                            {item.name}
                          </NavLink>
                        </NavItem>
                      ))}
                    </Nav>
                  </div>
                  <div className="tabsInnerContent">
                    <TabContent activeTab={activeTab} className="text-muted">
                      <TabPane tabId="1">
                        {activeTab === '1' && <CommentTab module={Modules.TICKET} />}
                      </TabPane>
                      <TabPane tabId="2">
                        {activeTab === '2' && <HistoryTab module={Modules.TICKET} key={update} />}
                      </TabPane>
                      {/* <TabPane tabId="3">
                        {activeTab === '3' && <WorkLogTab />}
                      </TabPane> */}
                    </TabContent>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={4} className="h-100" style={{borderLeft: '1px solid #DFE2EE'}} >
            <Card style={{boxShadow: 'unset', border: 'unset'}}>
              <CardBody>
              {projectStatus === ProjectStatuses.ONGOING &&  
              <div className="info-heading customBadge position-relative d-grid grid_custom_twoColumns align-items-center assigneeRyt pb-4">
                 
                 <h5 className="desc_common_heading mb-0">{t('Assignee')}</h5>
                 {/* <Box sx={{ display: 'flex', alignItems: 'flex-end'}} >
                   <Avatar />
                   <TextField id="input-with-sx" label="With sx" variant="standard" />
                 </Box> */}
                 {selectedAssginee && ticket.assignee !== null &&  (
                   <SearchDropDownListComponent
                   key={refreshOtherComponent.assignee}
                   size="small"
                   label={t("Assignee")}
                     defaultValue={selectedAssginee}
                     searchEnabled={false}
                     disabled={isDisabled || isLoading}
                     listCall={getUserList}
                     emitItem={(newValue) => {
                       if (newValue) {
                         if (ticket.assignee.id !== newValue.id) {
                           setSelectedAssginee({
                             id: newValue.id,
                             label: newValue.name,
                             profilePicture: newValue.profilePicture,
                           });
                           updateTicketDetails({
                             assigneeId: newValue?.id,
                           });
                         }
                       } else {
                         updateTicketDetails({ assigneeId: null });
                       }
                     }}
                     apiParams={assigneeApiParams}
                   />
                 )}
                 {ticket.assignee === null && (
                   <SearchDropDownListComponent
                     key={refreshOtherComponent.assignee}
                     label={t("Assignee")}
                     size="small"
                     searchEnabled={false}
                     disabled={isDisabled || isLoading}
                     listCall={getUserList}
                     emitItem={(newValue) => {
                       if (newValue) {
                         setSelectedAssginee({
                           id: newValue.id,
                           label: newValue.name,
                         });
                         updateTicketDetails({
                           assigneeId: newValue?.id,
                         });
                       } else {
                         setSelectedAssginee(null);
                         updateTicketDetails({ assigneeId: null });
                       }
                     }}
                     apiParams={assigneeApiParams}
                   />
                 )}
                 
               </div>
               }
                <div className="info-heading customBadge position-relative d-grid grid_custom_twoColumns align-items-center pb-2">
                  <h5 className="desc_common_heading mb-0">{t('Status')}</h5>
                  <SelectDropdown
                    className="mb-2 bg-custom-blue border-0"
                    // key={refreshOtherComponent.status}
                    label={ucFirst(selectedStatus?.name)}
                    style={{ background: ticket?.status?.color ? ticket?.status?.color  + '33': '#EBEDF533', color: ticket?.status?.color }}
                    disabled={stausDisable || isLoading}
                    key={selectedStatus?.name}
                    list={statusList}
                    emitSelectedValue={(newValue) => {
                      if (ticket.status.id !== newValue.id) {
                        setSelectedStatus({
                          id: newValue.id,
                          name: newValue.name,
                        });
                        changeTicketStatus(newValue.id);
                      }
                    }}
                  />
                </div>
                <div className="info-heading customBadge position-relative d-grid grid_custom_twoColumns align-items-center assigneeRyt pb-2">
                  <h5 className="desc_common_heading mb-0">{t('Priority')}</h5>
                  <div className="d-flex align-items-center">
                    <PriorityIcon className="me-2"  IconColor={selectedPriority?.color} label={selectedPriority?.label} />
                    <SearchDropDownListPaginationComponent
                      className="w-100"
                      variant={'standard'}
                      label={t("Priority")}
                      disabled={isDisabled}
                      defaultValue={selectedPriority?.id ? selectedPriority :  null}
                        listCall={AllPriorityList}
                        apiParams={{
                            projectId,
                        }}
                        emitItem={(newValue) => {
                          if (newValue && selectedPriority.id !== newValue.id) {
                            setSelectedPriority({
                              id: newValue.id,
                              label: newValue.name,
                            });
                            updateTicketDetails({ priorityId: newValue?.id });
                          }else {
                            updateTicketDetails({ priorityId: null });
                          }
                        }}
                      />
                    </div>
                </div>
                {/* <div className="dashTaskPriority d-flex align-items-center">
                  <PriorityIcon IconColor={ticket?.priority?.color} label={ticket?.priority?.name} />
                  <span style={{ color: ticket?.priority?.name, fontSize: '14px' }}>{ticket?.priority?.name}</span>
                </div> */}
                {/* <div className="border-bottom pb-4 pt-4 d-flex justify-content-between" > */}
                  <div className="rightDatePicker d-grid grid_custom_twoColumns align-items-center pb-3">
                  <h5 className="desc_common_heading mb-0">{t("Start Date")}</h5>
                    <FormControl>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          {ticket && (
                            <DatePicker
                            key={refreshOtherComponent.stDate}
                            slotProps={{ textField: { size: 'small' } }}
                              label={t("Start Date")}
                              value={
                                ticket.startDate
                                  ? dayjs(ticket.startDate)
                                  : null
                              }
                              format="MM/DD/YYYY"
                              disabled={isDisabled}
                              onChange={(date) => {
                                setTicket({
                                  ...ticket,
                                  startDate: date ? dayjs(date) : null,
                                });
                                setIsDateUpdate((prev) => !prev);
                              }}
                            />
                          )}
                        </DemoContainer>
                      </LocalizationProvider>
                    </FormControl>
                  </div>
                  <div className="rightDatePicker d-grid grid_custom_twoColumns align-items-center pb-4">
                  <h5 className="desc_common_heading mb-0">{t("End Date")}</h5>
                    <FormControl>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          {ticket && (
                            <DatePicker
                            key={refreshOtherComponent.edDate}
                            slotProps={{ textField: { size: 'small' } }}
                              label={t("End Date")}
                              value={
                                ticket.endDate
                                  ? dayjs(ticket.endDate)
                                  : null
                              }
                              options={{ minDate: tomDate }}
                              disabled={isDisabled}
                              onChange={(date) => {
                                setTicket({
                                  ...ticket,
                                  endDate: date ? dayjs(date) : null,
                                });
                                setIsDateUpdate((prev) => !prev);
                              }}
                            />
                          )}
                        </DemoContainer>
                      </LocalizationProvider>
                    </FormControl>
                  </div>
                {/* </div> */}
                <div className="reporter_section position-relative d-grid grid_custom_twoColumns align-items-center pb-3">
                  <h5 className="desc_common_heading mb-3">{t('Reporter')}</h5>
                  {/* <ul className="reporter_listing list-inline"> */}
                  <div className="single_reporter d-flex align-items-center mb-2">
                    {!ticket?.creator?.profilePicture &&
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltipp className="mytooltip">
                            {ticket?.creator?.name}
                          </Tooltipp>
                        }
                      >
                        <Avatar {...stringAvatar(ticket?.creator?.name)} />
                      </OverlayTrigger>
                    }
                    {ticket?.creator?.profilePicture &&
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltipp className="mytooltip">
                            {ticket?.creator?.name}
                          </Tooltipp>
                        }
                      >
                        <img
                          src={getUrl(ticket?.creator?.profilePicture)}
                          alt=''
                          className="rounded-circle header-profile-user"
                        />
                      </OverlayTrigger>
                    }
                    <p className="mb-0 ms-2">{ticket?.creator?.name}</p>
                  </div>
                  {/* </ul> */}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </>
      }
      {!ticketName && isLoading && <Loader /> }
        {/* {!ticketName && !isLoading && <NotFound/> } */}

      </Container>
      {isOpenSweetAlert && (
        <SweetAlert
          title={t("Are you sure want to delete this document") + '?'}
          warning
          showCancel
          confirmBtnText={t("Ok")}
          cancelBtnText={t("Cancel")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            handelDelete()
          }}
          onCancel={() => {
            setIsOpenSweetAlert(false)
          }}>
        </SweetAlert>
      )}
      <FilePreviewModal modal={modal} setModal={setModal} filePath={filePath} fileName={fileName} />
    </div>
  );
};

export default withTranslation() (TicketDetailsPage);
